export const allUnitsUrl='/api/units/all'
export const coursesUrl='/api/courses/all'
export const addMyCourseUrl='/api/add/mycourse'
export const getCourseUrl='/api/course/details'
export const unitNotesUrl='/api/unit/notes/all'
export const courseUnitsUrl='/api/course/units'
export const addContentUrl='/api/add/content'
export const uploadUrl='https://alex2kepler.pythonanywhere.com/upload'
export const addModeratorUrl='/api/add/moderator'
export const searchUrl='/api/search'
export const uploadVideoUrl='api/add/videos'
